import React from 'react';

const Loader = () => {
  return (
    <div className="loaderScreen">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;